<template>
	<div class="search-list">
		<div class="noData" v-if="noData">
			<img src="../../assets/images/noData1.png" alt="">
			<p>没有搜索到任何数据</p>
		</div>
		<div>
			<template v-for="item in searchedWriters">
				<expert-info :expertInfo="item"></expert-info>
			</template>
		</div>
		<div class="columns">
			<template v-for="item in searchedColumns">
				<item-block :itemContent="item" :searchType="columnsType"></item-block>
			</template>			
		</div>
		<div class="meetings">
			<template v-for="item in searchedMeetings">
				<item-block :itemContent="item" :searchType="meetingType"></item-block>
			</template>
		</div>
		<div class="instruments">
			
		</div>
	</div>
</template>
<script>
	import ExpertInfo from "../../components/Expert/ExpertInfo"
	import ItemBlock from "../../components/ItemBlock"
	import {OverallSearch} from "../../config/interface.js"
	export default{
		data(){
			return{
				searchKeyWord:'',    //关键词
				searchedColumns:[],    //被搜素的专栏
				searchedInstruments:[],  //被搜索的器械
				searchedMeetings:[],     //被搜索的会议
				searchedWriters:[],      //被搜索的作者
				meetingType:0,   
				columnsType:1,
				instrumentsType:2,
				noData:false
			}
		},
		components:{
			ExpertInfo,
			ItemBlock
		},
		mounted(){
			this.searchKeyWord=this.$route.query.searchKeyWord;
			this.getSearchList();
		},
		methods:{
			//搜索列表
			getSearchList(){
				const url=OverallSearch;
				const method='POST';
				let params={
					keywords:this.searchKeyWord
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.searchedWriters=data.writers;
						data.meetings.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
							this.searchedMeetings.push(item);
						})
						let follow=data.columns_follows;
						data.columns.forEach((item,index)=>{
							item.follows=follow[item.id];
						})
						this.searchedColumns=data.columns;
						this.searchedInstruments=data.instruments;
						if(data.meetings.length==0&&data.columns.length==0&&data.instruments.length==0&&data.writers.length==0){
							this.noData=true;
						}
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.search-list{
		padding:14px 12px;
		.noData{
			position:absolute;
			left:50%;
			top:30%;
			transform:translate(-50%,-50%);
			img{
				width:220px;
			}
			p{
				margin-top: 10px;
				text-align:center;
				color: #666;
				font-size:14px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Search/list.vue